import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { styled } from '@mui/system';

const AppFooterNavWrapper = styled(Box, {})(() => ({
    '.scrollDown': {
        position: 'absolute',
        bottom: 10,
        width: '100vw',
        left: 0,
        zIndex: 999,
        textAlign: 'center',
        fontFamily: 'Calmetta, sans-serif',
        fontSize: 20,
        lineHeight: '8px',
        textTransform: 'uppercase',
        cursor: 'pointer',
        '& svg': {
            animation: '1s bounce infinite alternate',
        },
        '&:focus': {
            backgroundImage: 'none',
            outline: 0,
            boxShadow: 'none',
        },
        '&:active': {
            backgroundImage: 'none',
            outline: 0,
            boxShadow: 'none',
        },
    },
    '@keyframes bounce': {
        from: {
            transform: 'translateY(4px)',
        },
        to: {
            transform: 'translateY(9px)',
        },
    },
    '@-webkit-keyframes bounce': {
        from: {
            transform: 'translateY(4px)',
        },
        to: {
            transform: 'translateY(9px)',
        },
    },
}));

const AppFooterNav = ({ fullpageApi }) => {
    const next = () => {
        fullpageApi.moveSectionDown();
    };

    return (
        <AppFooterNavWrapper>
            <div className="scrollDown" role="button" tabIndex={0} onClick={() => next()} onKeyDown={() => next()}>
                <KeyboardArrowDownIcon />
            </div>
        </AppFooterNavWrapper>
    );
};

AppFooterNav.propTypes = {
    fullpageApi: PropTypes.object,
};

AppFooterNav.defaultProps = {
    fullpageApi: null,
};

export default AppFooterNav;
